import React from "react";
import DefaultButton from '../../../components/DefaultButton';
import { useModal } from "../../../contexts/ModalContext";

export default function SmallWorkforce({data}) {
  const {openQueryModal} = useModal();
  return (
    <>
      <section className="small-workforce-area">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-4 col-md-5">
              <img src={data.img} alt="workforce-image" />
            </div>

            <div className="col-lg-8 col-md-7">
              <span>{data?.head}</span>
              <p>{data?.desc}</p>
              <DefaultButton text={data?.btn} onClick={openQueryModal} to={data?.slug} />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}